// removed by extract-text-webpack-plugin
module.exports = {"input":"input_8XYwm","button":"button_gLVAq","main":"main_13fLM","disabled":"disabled_1Or3-"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/container/login/style.css
 ** module id = 947
 ** module chunks = 0
 **/